// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LR2M","label":"styles_label__3v0by"};